import { Cookies } from 'quasar'
import VueI18n from 'vue-i18n'
import { config, messages } from '../i18n'
import { QuasarPluginContext } from '../types'

function getCookies (ssrContext: any): Cookies {
  return process.env.SERVER
    ? Cookies.parseSSR(ssrContext)
    : Cookies
}

export default ({ app, ssrContext, Vue, ...ctx }: QuasarPluginContext) => {
  Vue.use(VueI18n)

  let locale = 'ru' // (Quasar.lang.getLocale() || 'ru').split('-').shift()
  const cookieLocale = getCookies(ssrContext).get('locale')
  if (cookieLocale) {
    locale = cookieLocale
  }
  if (!locale || !messages.hasOwnProperty(locale)) {
    locale = 'en'
  }

  app.i18n = new VueI18n({ ...config, locale })
}
